import { Button } from '@ethena/shared-ui/src/components/Button'
import { useIsHydrated } from '@ethena/shared-ui/src/hooks/useIsHydrated'
import Link from 'next/link'

import { usePostHog } from 'posthog-js/react'
import { useEffect } from 'react'

import { REDEMPTION_START_DATE } from '@/constants/redemption'
import useUserStore from '@/store/user-store'

export const RedemptionToast = () => {
  const { hasAcknowledgedRedemptionToast, setHasAcknowledgedRedemptionToast } = useUserStore()
  const isHydrated = useIsHydrated()

  const posthog = usePostHog()

  const onClick = () => {
    setHasAcknowledgedRedemptionToast()
    posthog.capture('RedemptionToast acknowledged')
  }

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const hasAcknowledgedToastInSession = sessionStorage.getItem('hasAcknowledgedRedemptionToast')

      if (hasAcknowledgedToastInSession === 'true') {
        setHasAcknowledgedRedemptionToast()
      }
    }
  }, [setHasAcknowledgedRedemptionToast])

  const isOpen = !hasAcknowledgedRedemptionToast && isHydrated

  if (!isOpen) return null

  return (
    <div role="dialog" aria-labelledby="redemption-toast-title" className="absolute top-[70px] sm:top-[90px] left-0">
      <div className="bg-black border border-[#3A3A3A] rounded-[20px] p-4">
        <h2 id="redemption-toast-title" className="max-w-[790px] text-[24px]">
          Information for holders of USDe tokens of Ethena GmbH: On {REDEMPTION_START_DATE}, Ethena GmbH activated a
          plan for the redemption of USDe. You can find more information on the redemption process to be followed here.
        </h2>

        <div className="mt-4 flex flex-wrap items-center gap-2">
          <Button variant="secondary" size="small" asChild>
            <Link href="/redemption" onClick={onClick}>
              Further Details on Redemption Process
            </Link>
          </Button>
          <Button variant="text" size="small" onClick={onClick}>
            Dismiss
          </Button>
        </div>
      </div>
    </div>
  )
}
